import { Button, Card } from 'antd';
import { FC } from 'react';

import { SearchConsoleAccountOTPAuthenticator } from '../SearchConsoleAccountOTPAuthenticator';
import { SearchConsoleAccountOTPForm } from '../SearchConsoleAccountOTPForm';


interface Props {
  searchConsoleAccountId: string;
  isOtpSetted: boolean;
  refreshInterval: number;
  mode: 'view' | 'create';
  handleSetCreateMode: () => void;
  handleSetViewMode: () => void;
}

export const SearchConsoleAccountOTPView: FC<Props> = ({
  searchConsoleAccountId,
  isOtpSetted,
  refreshInterval,
  mode,
  handleSetCreateMode,
  handleSetViewMode
}) => {
  return (
    <Card
      size="small"
      style={{ width: '100%' }}
      styles={{ body: { paddingBlock: 0, height: 64, display: 'flex', alignItems: 'center' } }}
    >
      {
        mode === 'view'
          ? (
            isOtpSetted
              ? (
                <SearchConsoleAccountOTPAuthenticator
                  searchConsoleAccountId={ searchConsoleAccountId }
                  refreshInterval={ refreshInterval }
                />
              )
              : (
                <Button
                  type="link"
                  size="large"
                  block
                  onClick={ handleSetCreateMode }
                >
                  Додати Google OTP
                </Button>
              )
          )
          : (
            <SearchConsoleAccountOTPForm
              searchConsoleAccountId={ searchConsoleAccountId }
              handleCloseCreateMode={ handleSetViewMode }
            />
          )
      }
    </Card>
  );
};
